function hiddenSeries(visual, vcgid) {
    /// <summary>
    /// This object contains a simple handler for adding and removing hidden series in the ramp chart.<br/>
    /// The cart sends a vcmq message - with the current index of the series - if a series gets hidden/shown.<br/>
    /// When reloading the chart this list is given to the chart<br/>
    /// as visual parameter. After the chart has loaded it hides the specific series. <br/>
    /// Note: If the chart, signal, meta or rule selection changes the list gets reseted.<br/>
    /// </summary>
    this.lstHiddenSeries = [];
    this.visual = visual;
    this.vcgid = vcgid;
    _VCMQ.addConsumer(this.vcgid);
    _VCMQ.consume(visual, this.vcgid, this.events);
}

hiddenSeries.prototype.events = function (event) {
// ReSharper disable once UseOfImplicitGlobalInFunctionScope
    var me = _hs;
    switch (event.msg) {
        case 'CHART_SERIES_HIDE':

            me.add(event.values); break;
        case 'CHART_SERIES_SHOW':
            me.remove(event.values); break;
        case 'CHART_SERIES_CLEAR':
            _VCMQ.produce(me.visual, me.vcgid, 'CHART_DIRTY', '');
            me.clear(); break;
    }
}

hiddenSeries.prototype.add = function (seriesid) {
    var me = this;
    try {
        var index = me.lstHiddenSeries.indexOf(parseInt(seriesid));
        if (index < 0) { me.lstHiddenSeries.push(parseInt(seriesid)); }
        return false;
    } catch (ex) { writeError('hiddenSeries.js.hiddenSeries.add', ex); return false; }

}

hiddenSeries.prototype.remove = function (seriesid) {
    var me = this;
    try {
        var index = me.lstHiddenSeries.indexOf(parseInt(seriesid));
        if (index > -1) { me.lstHiddenSeries.splice(index, 1); }
        return false;
    } catch (ex) { writeError('hiddenSeries.js.hiddenSeries.remove', ex); return false; }

}

hiddenSeries.prototype.clear = function () {
    this.lstHiddenSeries = [];
}

